import { HttpErrorResponse } from '@angular/common/http';
import { GENERAL_ERROR_MESSAGE } from '@shared/models/messages';

export async function parseErrorMessageFromBlob(error: HttpErrorResponse): Promise<string> {
  const isBlobError = error?.error instanceof Blob && error?.error?.type === 'application/json';
  if (!isBlobError) {
    return Promise.resolve(GENERAL_ERROR_MESSAGE);
  }

  const responseData = await error?.error?.text();
  return JSON.parse(responseData).message ?? GENERAL_ERROR_MESSAGE;
}
